<div kalDialogContent
     [kalLoading]="loading">

    <kal-table
        [columns]="columns"
        [dataSource]="ordersList"
        [selection]="selection"
        class="no-action">

        <tr *kalHeaderRowDef kal-header-row></tr>

        <ng-container kalColumn="DateCommande">
            <td *kalBodyCell="let element">{{ element.DateCommande  | date:'dd/MM/yyyy HH:mm:ss' }}</td>
        </ng-container>

        <ng-container kalColumn="MontantTotalCommande">
            <td *kalBodyCell="let element">{{ (element.MontantTotalCommande || 0) | currency: 'EUR' }}</td>
        </ng-container>

    </kal-table>

</div>

<div kalDialogFooter>

    <div class="gup-C-validationArea gup-O-list">

        <div class="gup-O-list__item">
            <kal-button kalTheme="primary"
                        [disabled]="hasNotSelectedOrder"
                        (click)="submit()">
                Valider
            </kal-button>
        </div>

        <div class="gup-O-list__item">
            <kal-button kalTheme="secondary"
                        (click)="close()">
                Annuler
            </kal-button>

        </div>

    </div>

</div>
